export default __webpack_public_path__ + "static/media/Boots of the Inconceivable.328b35b4.jpg";